import { Component, OnDestroy, OnInit } from '@angular/core';
import { InterestedHost, InterestedHostClient, SisterWebsite } from '../Services/WOWApi.Service';
import { CommonServices } from '../Common/CommonServices';
import { Subscription } from 'rxjs';
import { CommonService } from '../Services/common.service';
import { InterestedHostInfoComponent } from './interested-host-info/interested-host-info.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-interested-host-approval',
    templateUrl: './interested-host-approval.component.html',
    styleUrls: ['./interested-host-approval.component.css'],
    standalone: false
})
export class InterestedHostApprovalComponent implements OnInit, OnDestroy {
  requests:InterestedHost[]=[];
  sisterWebsites:SisterWebsite[] = [];
  showSpinner: boolean = false; 
  sisterWebsiteId:number = 0;
  isMobileView = false;
  subscription: Subscription;
  constructor(
    private interestedHostClient: InterestedHostClient, 
    private commonServices: CommonServices, 
    private commonService: CommonService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
  this.LoadRequests();  
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  LoadRequests()
  {
     
    this.interestedHostClient.getRequests().subscribe(x => {

      this.requests = x;
       
    });
    this.interestedHostClient.getSisterWebsites().subscribe(x => {
this.sisterWebsites = x;
    });
  }

  Approve(id) {
    if(this.sisterWebsiteId == 0 || this.sisterWebsiteId == undefined || this.sisterWebsiteId == null)
    {
      this.commonServices.showMessage("Error", "Please select sister website");
      return;
    }
    this.showSpinner = true;
    this.interestedHostClient.approveRequest(id, this.sisterWebsiteId).subscribe(x => {
      this.showSpinner = false;
      this.commonServices.showMessage("Success", x.message);
      if (x.status === true) {
        this.LoadRequests();
      }
    });
  }

  SetSisterWebsite(e) {
    this.sisterWebsiteId = e.value;
  }

  Reject(id) {
    this.showSpinner = true;
    this.interestedHostClient.rejectRequest(id).subscribe(x => {
      this.showSpinner = false;
      this.commonServices.showMessage("Success", "Request has been rejected");
       if (x.status === true) {
        this.LoadRequests();
       }
    });
  }

  onHostInfo(host: InterestedHost) {
    this.dialog.open(InterestedHostInfoComponent, {
      width: '60%',
      maxHeight: '70%',
      data: host
    });
  }
}
